import React, { useEffect, useState } from 'react';
import ResourceListing from './ResourceListing';
import AddResourceFormWrapper from '../add/AddResourceFormWrapper';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setIsTableLoading ,
  setItems,
  setTotalItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
} from "src/redux/slices/ResourceSlice";
import { useGetAllResourcesQuery , useDeleteResourcesMutation } from 'src/services/ResourceServices';
import { RxPencil1 } from 'react-icons/rx';
import { UserModuleActionTypes, UserModuleNameTypes } from 'src/models/userAccess/UserAccess.model';
import { MdDeleteOutline } from 'react-icons/md';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import EditResourceFormWrapper from '../Edit/EditResourceFormWrapper';
import { showToast } from 'src/utils/showToaster';

type Props = {};

const ResourceListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const [isOpenAddForm , setIsOpenAddForm] = useState(false) 
  const [isOpenEditForm, setIsOpenEditForm] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [deleteResource] = useDeleteResourcesMutation()

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
  useSelector((state: RootState) => state.resource);

  const getActionOptions = (questionId: string) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          setSelectedId(questionId);
          setIsOpenEditForm(true);
        },
        actionName: UserModuleActionTypes.EDIT,
        moduleName: UserModuleNameTypes.RESOURCE,
      },
      {
        label: (
          <div className="flex gap-2 items-center text-red-600 font-semibold">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Resource ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result?.isConfirmed) {
                deleteResource({ id: questionId }).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.RESOURCE,
      },
    ];
  };

  const {data , isLoading , isFetching} = useGetAllResourcesQuery( {
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["title"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  })  

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  return (
    <div>
      <ResourceListing
       rows={items}
       getActionOptions={getActionOptions}
       onAddNew={()=>{setIsOpenAddForm(true)}}
       paginationProps={{
        isTableLoading,
        totalItems,
        page,
        rowsPerPage,
        searchValue,
        setPage: (newPage) => dispatch(setPage(newPage)),
        setRowsPerPage: (newRowsPerPage) =>
          dispatch(setRowsPerPage(newRowsPerPage)),
        setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
      }}
      />
      {isOpenAddForm && <AddResourceFormWrapper onClose={()=>{setIsOpenAddForm(false)}} />}
      {isOpenEditForm && <EditResourceFormWrapper selectedId={selectedId} onClose={()=>{setIsOpenEditForm(false)}} />}
    </div>
  );
};

export default ResourceListingWrapper;